import React, { useState } from 'react'


const PDFviewer = ({imgPreview}) => {
  
   
  //  let base64Data= Object.values(imgPreview)
 
  //  console.log(base64Data)

  //  function base64ToBlob(base64String, contentType = '') {
  //   const sliceSize = 1024;
  //   const byteCharacters = atob(base64String);
  //   const bytesLength = byteCharacters.length;
  //   const slicesCount = Math.ceil(bytesLength / sliceSize);
  //   const byteArrays = new Array(slicesCount);
  
  //   for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
  //     const begin = sliceIndex * sliceSize;
  //     const end = Math.min(begin + sliceSize, bytesLength);
  
  //     const bytes = new Array(end - begin);
  //     for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
  //       bytes[i] = byteCharacters[offset].charCodeAt(0);
  //     }
  //     byteArrays[sliceIndex] = new Uint8Array(bytes);
  //   }
  
  //   return new Blob(byteArrays, { type: contentType });
  // }
  // const blob = base64ToBlob(base64Data[0].split(",").pop(), 'application/pdf');
  //  console.log(blob)
  //  const pdfBlob = new Blob([atob(base64Data[0].split(",").pop())], { type: 'application/pdf' });
  //  const pdfUrl = URL.createObjectURL(blob);

// console.log(pdfUrl)

  // react-pdf package is not working so now pdf viewer is set in iframe  
  return (
  
<div className='align-items-center d-flex h-100 justify-content-center px-5'>
      
<iframe src={imgPreview} width="100%" height={"100%"} style={{ border: "none", maxHeight:"580px"}} />
</div>
   


 )
}

export default PDFviewer
